// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"_2ouqcjsYfWtFDW6rf2JgCd"};